// pattern for react-number-format, shared by phone input and phone view
export const PHONE_VIEW_FORMAT = '+1 (###) ### ####';
// country code stored in form value, must match the one in PHONE_VIEW_FORMAT
export const COUNTRY_CODE_PREFIX = '+1';
